import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { css } from "styled-components";
import { cssFromObject } from "../lib/styleUtils";
import { embeddedLinkTheme } from "./theme";
var makeOverriddenColorTheme = function(theme, color) {
    var overridePart = function(themePart) {
        return _object_spread_props(_object_spread({}, themePart), {
            color: color,
            "text-decoration-color": color
        });
    };
    return _object_spread_props(_object_spread({}, theme), {
        base: overridePart(theme.base),
        hover: _object_spread_props(_object_spread({}, overridePart(theme.hover)), {
            filter: "brightness(0.8)"
        })
    });
};
export var EmbeddedLinkStyles = function(param) {
    var styledComponentsTheme = param.theme, color = param.color;
    var _styledComponentsTheme_embeddedLink;
    var theme = (_styledComponentsTheme_embeddedLink = styledComponentsTheme === null || styledComponentsTheme === void 0 ? void 0 : styledComponentsTheme.embeddedLink) !== null && _styledComponentsTheme_embeddedLink !== void 0 ? _styledComponentsTheme_embeddedLink : embeddedLinkTheme;
    // If a color is provided we overide the color defined in the theme
    var overriddenTheme = isNotUndefined(color) ? makeOverriddenColorTheme(theme, color) : theme;
    return css([
        "display:inline;width:auto;cursor:pointer;",
        " &:hover,&:focus,&:focus-within{",
        "}&:active{",
        "}&:disabled{",
        " cursor:not-allowed;}"
    ], cssFromObject(overriddenTheme.base), cssFromObject(overriddenTheme.hover), cssFromObject(overriddenTheme.active), cssFromObject(overriddenTheme.disabled));
};
